export const Created = "Created";
export const Admin = "Admin";
export const Received = "Received";
export const Ready = "Ready";
export const Delivered = "Delivered";
export const Payment = "Payment";
export const Completed = "Completed";